import { useState } from 'react';
import { GroupBadge } from './group-badge';

interface GroupListCellProps {
  groups: number[];
  groupMode?: 'allow' | 'deny';
  groupMap: Record<string, string>;
  /** Badges shown before collapsing behind a "+N more" toggle. */
  collapseAfter?: number;
}

/**
 * Group list for table cells: named badges instead of raw IDs, a deny-mode
 * marker when the list is an exclusion list, and expand/collapse once the
 * list gets long.
 */
export function GroupListCell({ groups, groupMode, groupMap, collapseAfter = 3 }: GroupListCellProps) {
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? groups : groups.slice(0, collapseAfter);
  const hidden = groups.length - visible.length;

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {groupMode === 'deny' && (
        <span className="eo-chip eo-chip--err" title="Deny mode: every group EXCEPT these is allowed">
          all except
        </span>
      )}
      {visible.map((groupId) => {
        const key = String(groupId);
        return (
          <GroupBadge
            key={key}
            groupId={key}
            groupName={groupMap[key] ?? `Group ${key}`}
            variant="default"
          />
        );
      })}
      {(hidden > 0 || expanded) && (
        <button
          type="button"
          onClick={() => setExpanded((v) => !v)}
          className="font-mono text-[10px] tracking-label uppercase text-crimson-hover hover:text-white"
        >
          {expanded ? '− collapse' : `+${hidden} more`}
        </button>
      )}
    </div>
  );
}
